import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { JuniorPilotEffect } from './junior-pilot.effect';
import { juniorPilotReducer } from './junior-pilot.reducer';
import { JUNIOR_PILOT_STORE_NAME, JuniorPilotState } from './junior-pilot.state';

/** Token of the JuniorPilot reducer */
export const JUNIOR_PILOT_REDUCER_TOKEN = new InjectionToken<ActionReducer<JuniorPilotState, Action>>(
  'Feature JuniorPilot Reducer'
);

/** Provide default reducer for JuniorPilot store */
export function getDefaultJuniorPilotReducer() {
  return juniorPilotReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(JUNIOR_PILOT_STORE_NAME, JUNIOR_PILOT_REDUCER_TOKEN),
    EffectsModule.forFeature([JuniorPilotEffect]),
  ],
  providers: [{ provide: JUNIOR_PILOT_REDUCER_TOKEN, useFactory: getDefaultJuniorPilotReducer }],
})
export class JuniorPilotStoreModule {
  public static forRoot<T extends JuniorPilotState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<JuniorPilotStoreModule> {
    return {
      ngModule: JuniorPilotStoreModule,
      providers: [{ provide: JUNIOR_PILOT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
